'use strict';

module.exports = 'data-reactid';


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-three-renderer/lib/utils/idPropertyName.js
 ** module id = 196
 ** module chunks = 0
 **/